import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  pulse?: boolean;
  variant?: "accent" | "primary";
}

const Dot = ({ classNames = [], pulse = false, variant = "accent" }: Props) => (
  <div className={cn("Dot", [{ pulse }, `variant-${variant}`], classNames)} />
);

export default Dot;
